import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

const items = [
  { icon: 'ri-vip-diamond-line', title: 'Selección estratégica', desc: 'No trabajamos por volumen, sino por selección precisa y encaje real entre empresa y talento' },
  { icon: 'ri-global-line', title: 'Experiencia real', desc: 'Fundada por profesionales que vivieron procesos de colocación internacional' },
  { icon: 'ri-user-settings-line', title: 'Procesos personalizados', desc: 'Cada cliente recibe atención individualizada y estrategia a medida' },
  { icon: 'ri-shield-check-line', title: 'Enfoque estratégico', desc: 'Análisis profundo y confidencialidad garantizada en cada proceso' },
  { icon: 'ri-time-line', title: 'Relaciones a largo plazo', desc: 'Construimos vínculos duraderos, no transacciones puntuales' },
  { icon: 'ri-star-line', title: 'Calidad sobre cantidad', desc: 'Cada conexión es cuidadosamente diseñada para el éxito mutuo' },
];

export default function ValueProposition() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: gridRef, visibleItems } = useStaggerAnimation(6, { threshold: 0.08 });

  return (
    <section className="py-28 bg-[#1A2B4A]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div
            ref={titleRef as React.RefObject<HTMLDivElement>}
            className="lg:col-span-4 flex items-center"
            style={{
              opacity: titleVisible ? 1 : 0,
              transform: titleVisible ? 'translateX(0)' : 'translateX(-40px)',
              transition: 'opacity 0.8s ease, transform 0.8s ease',
            }}
          >
            <h2 className="text-5xl font-bold text-white leading-tight">
              Por qué BN Āgenzia<br />es diferente
            </h2>
          </div>

          <div className="lg:col-span-8">
            <div
              ref={gridRef as React.RefObject<HTMLDivElement>}
              className="grid grid-cols-1 md:grid-cols-2 gap-8"
            >
              {items.map((item, i) => (
                <div
                  key={item.title}
                  className="space-y-4 border border-white/10 rounded-xl p-6 hover:border-white/25 transition-all bg-white/5"
                  style={{
                    opacity: visibleItems[i] ? 1 : 0,
                    transform: visibleItems[i] ? 'translateY(0)' : 'translateY(32px)',
                    transition: 'opacity 0.55s ease, transform 0.55s ease',
                  }}
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-white/15">
                    <i className={`${item.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white">{item.title}</h3>
                  <p className="leading-relaxed text-white/70">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
